module.exports = __webpack_public_path__ + "static/s2-4-vicious-d-9f6799817d5d3426d9b4e2ea7b3cdc6a.jpg";